const THREAD_SPEAKER_COLORS = ['#4B34B8', '#00D468', '#FF4FB3'] as const;

export const getSpeakerOrderMap = (
  contents: ReadonlyArray<{ speaker?: string | null }>
): Map<string, number> => {
  const map = new Map<string, number>();
  let nextIndex = 0;
  for (const content of contents) {
    const speaker = content.speaker ?? '';
    if (speaker && !map.has(speaker)) {
      map.set(speaker, nextIndex++);
    }
  }
  return map;
};

export const getThreadSpeakerColor = (speakerIndex: number): string => {
  return (
    THREAD_SPEAKER_COLORS[speakerIndex % THREAD_SPEAKER_COLORS.length] ?? THREAD_SPEAKER_COLORS[0]
  );
};
